import DocumentosTab from "./DocumentosTab";
import { useDispatch, useSelector } from "react-redux";
import {
  getDetalhesCliente,
  getDocumentos,
  isBaixandoArquivos,
  isCarregandoDetalhesCliente,
  isSubindoArquivos,
} from "../../selectors/clientes.selectors";
import { useCallback } from "react";
import { actions } from "../../actions/clientes.actions";
import { actions as workflowActions } from "../../actions/workflow.actions";
import { actions as documentoActions } from "../../actions/documentos.actions";
import { toast } from "react-toastify";
import { getUsuarioLogado } from "../../selectors/usuario.selectors";

const DocumentosTabConnected = () => {
  const dispatch = useDispatch();
  const cliente = useSelector(getDetalhesCliente);
  const data = useSelector(getDocumentos);
  const uploading = useSelector(isSubindoArquivos);
  const downloading = useSelector(isBaixandoArquivos);
  const loading = useSelector(isCarregandoDetalhesCliente);
  const usuario = useSelector(getUsuarioLogado);

  const handleUpload = useCallback(
    ({ id, padrao, arquivos }, ok, nok) => {
      if (nok.length > 0) {
        toast.error("");
      } else {
        switch (padrao) {
          case "IA":
            dispatch(
              documentoActions.exibirIA(true, {
                id,
                files: ok,
              })
            );
            break;
          default:
            dispatch(actions.uploadDocumento.request({ id, files: ok }));
            break;
        }
      }
    },
    [dispatch]
  );
  const handleDownload = useCallback(
    ({ tipo, id }) => {
      dispatch(actions.downloadDocumento.request({ tipo, id }));
    },
    [dispatch]
  );
  const handleTemplate = useCallback(
    ({ id, preencherAutomaticamente = false }) => {
      dispatch(actions.downloadTemplate.request({ id, preencherAutomaticamente }));
    },
    [dispatch]
  );
  const handleDelete = useCallback(
    ({ id }, documento) => {
      dispatch(actions.removerArquivo.request({ id, documento }));
    },
    [dispatch]
  );
  const handleAddDocument = useCallback(
    (e, chk) => {
      e.stopPropagation();
      dispatch(
        workflowActions.exibirDocumentoManual({
          show: true,
          id: cliente.id,
          tipo: "cliente",
          checklist: chk,
        })
      );
    },
    [dispatch, cliente]
  );
  return (
    <DocumentosTab
      data={data}
      loading={loading}
      handleUpload={handleUpload}
      handleDownload={handleDownload}
      handleDelete={handleDelete}
      handleTemplate={handleTemplate}
      handleAddDocument={handleAddDocument}
      uploading={uploading}
      downloading={downloading}
      perfil={usuario.perfil}
    />
  );
};

export default DocumentosTabConnected;
